<div class="header-no-register" [class.hidden]="isAuthorized() && !isAuthorizedHeaderLocked()">
  <div class="header-no-register__wrapper">
    <div class="logo logo--partner" [class.logo--static]="isHeaderNavigationLocked()">
      <a [attr.href]="isHeaderNavigationLocked() ? null : '/'">
        <img alt="logo" fill ngSrc="assets/img/logo.svg">
      </a>
    </div>
  </div>
</div>
